import {IRegistrationAnalytics} from "./registration-analytics.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {AdditionalActionName} from "@sparkware/uc-sdk-core/lib/apps/registration/registration.interfaces";

interface IRegistrationEventProps{
    stepIndex:number;
    action:string;
    label?:string;
}

export class RegistrationAnalytics implements IRegistrationAnalytics{
    constructor(private readonly services: IServiceFactoryExtended) {
        services.sdk.events.onRegistrationCompleted(() => {
            this._onRegistrationCompleted();
        });
        services.sdk.events.onBeginLoginFromRegistration(() => {
            this._onBeginLoginFromRegistration();
        });
        services.sdk.events.onLoginCompletedAfterRegistration(() => {
            this._onLoginCompletedAfterRegistration();
        });
        services.sdk.events.onLoginFailedAfterRegistration(() => {
            this._onLoginFailedAfterRegistration();
        });
    }

    private _onRegistrationCompleted = () => {
        const eventProps:IRegistrationEventProps = {
            stepIndex: 0,
            action: 'Registration',
            label: 'Completed'
        }
        this._onSendRegistrationElasticEvent(eventProps);
    }

    private _onBeginLoginFromRegistration = () => {
        const eventProps:IRegistrationEventProps = {
            stepIndex: 1,
            action: 'Begin',
            label: 'Login'
        }
        this._onSendRegistrationElasticEvent(eventProps);
    }

    private _onLoginCompletedAfterRegistration = () => {
        const eventProps:IRegistrationEventProps = {
            stepIndex: 2,
            action: 'Login',
            label: 'Successful'
        }
        this._onSendRegistrationElasticEvent(eventProps);
    }

    private _onLoginFailedAfterRegistration = () => {
        const eventProps:IRegistrationEventProps = {
            stepIndex: 2,
            action: 'Login',
            label: 'Failed'
        }
        this._onSendRegistrationElasticEvent(eventProps);
    }

    private _onSendRegistrationElasticEvent(eventProps:IRegistrationEventProps):void{
        try {
            this.services.analytics.sendOrbitUserFlowEvent('Registration_Event', eventProps.action, eventProps.label, eventProps.stepIndex);
        } catch (e) {
            console.log('Error sending Registration Handler Analytics to elastic search', e);
        }
    }

    public beginAdditionalAction(action:AdditionalActionName):void{
        const eventProps:IRegistrationEventProps = {
            stepIndex: 3,
            action: action,
            label: 'Begin'
        }
        this._onSendRegistrationElasticEvent(eventProps);
    }

    public endAdditionalAction(action:AdditionalActionName):void{
        const eventProps:IRegistrationEventProps = {
            stepIndex: 4,
            action: action,
            label: 'End'
        }
        this._onSendRegistrationElasticEvent(eventProps);
    }
}